import { render } from "./DialogConfirmSelectedSpecialSeat.vue?vue&type=template&id=3ee2fa09"
import script from "./DialogConfirmSelectedSpecialSeat.vue?vue&type=script&lang=js"
export * from "./DialogConfirmSelectedSpecialSeat.vue?vue&type=script&lang=js"
script.render = render

export default script